import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../reducers';
import { currentUser } from '../auth';
import { environment } from '../../../environments/environment';
import { HttpUtilsService } from '../_base/crud';
import { AdditionalStep } from '../models/additional-step.model';

const API_BASE = environment.TIMELINE_BASE;

@Injectable()
export class AdditionalStepsService {
  private companyId;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
  }

  getAdditionalSteps(task_template_id: number) {
    return this.http.get<any>(
      `${API_BASE}/companies/${this.companyId}/additional_steps_template/${task_template_id}`,
    );
  }

  addAdditionalSteps(body, task_template_id): Observable<AdditionalStep[]> {
    return this.http.post<any>(
      `${API_BASE}/companies/${this.companyId}/additional_steps_template/task-template/${task_template_id}`,
      body,
    );
  }

  updateAdditionalSteps(body, additional_setp_template_id): Observable<AdditionalStep[]> {
    return this.http.put<any>(
      `${API_BASE}/companies/${this.companyId}/additional_steps_template/${additional_setp_template_id}`,
      body,
    );
  }
  deleteAdditionalStep(additional_step_id) {
    return this.http.delete<any>(
      `${API_BASE}/companies/${this.companyId}/additional_steps_template/${additional_step_id}`,
    );
  }

  searchAdditionalSteps(task_template_id, term) {
    return this.http.get<any>(
      `${API_BASE}/companies/${this.companyId}/additional_steps_template/search?term=${term}&task_template_id=${task_template_id}`,
    );
  }

  searchCustomKeys(additional_step_id) {
    return this.http.get<any>(
      `${API_BASE}/companies/${this.companyId}/additional_steps_template/${additional_step_id}/keys`,
    );
  }
  updateOrderAdditionalStep(additional_steps_template) {
    return this.http.put<any>(
      `${API_BASE}/companies/${this.companyId}/additional_steps_template/order`,
      { additional_steps_template },
    );
  }
}
